var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components/native';
import Button from '../Button';
import theme from '../../theme';
const CancelButton = styled((_a) => {
    var { theme, label, btnTheme } = _a, rest = __rest(_a, ["theme", "label", "btnTheme"]);
    return (<Button btnTheme={btnTheme} {...rest}>
    <Button.Text btnTheme={btnTheme}>{label}</Button.Text>
  </Button>);
}) `
  height: ${({ theme }) => theme.sixtyPT};
  width: auto;
  padding-right: ${({ theme }) => theme.fortyPT};
  padding-left: ${({ theme }) => theme.fortyPT};
  ${props => props.customStyle}
`;
CancelButton.defaultProps = {
    theme: {
        sixtyPT: theme.sixtyPT,
        fortyPT: theme.fortyPT,
        thirtyPT: theme.thirtyPT,
    },
};
export default CancelButton;
